module.exports = __webpack_public_path__ + "img/locked.5d5867f7.svg";